module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rootDiv"
    }
  }, [_c('alert'), _vm._v(" "), _c('webgl-detect'), _vm._v(" "), _c('router-view', {
    key: _vm.$route.fullPath
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6fe9077c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe9077c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 486
// module chunks = 1